/**
 * Custom escape/unescape functions that are browser-compatible
 * Replaces deprecated global escape/unescape functions
 */

export function myunescape(str: string): string {
  if (!str?.length) {
    return ''
  }
  let result = ''
  const hex2 = /^[\da-f]{2}$/i
  const hex4 = /^[\da-f]{4}$/i
  let index = 0
  while (index < str.length) {
    const chr = str.charAt(index++)
    let part: string
    if (chr === '%') {
      if (str.charAt(index) === 'u') {
        part = str.slice(index + 1, index + 5)
        if (hex4.exec(part)) {
          result += String.fromCharCode(parseInt(part, 16))
          index += 5
          continue
        }
      } else {
        part = str.slice(index, index + 2)
        if (hex2.exec(part)) {
          result += String.fromCharCode(parseInt(part, 16))
          index += 2
          continue
        }
      }
    }
    result += chr
  }
  return result
}

const hex = function (code: number, length: number): string {
  let result = code.toString(16)
  while (result.length < length) {
    result = '0' + result
  }
  return result
}

export function myescape(str: string): string {
  if (!str?.length) {
    return ''
  }
  let result = ''
  let index = 0
  const raw = /[\w*+\-./@]/
  while (index < str.length) {
    const chr = str.charAt(index)
    index += 1
    let code: number
    if (raw.exec(chr)) {
      result += chr
    } else {
      code = chr.charCodeAt(0)
      if (code < 256) {
        result += '%' + hex(code, 2).toUpperCase()
      } else {
        result += '%u' + hex(code, 4).toUpperCase()
      }
    }
  }
  return result
}
